import React from 'react';
import PropTypes from 'prop-types';

import PDPAlertBar from '../PDPAlertBar';
import PDPNotifyOnStock from '../PDPNotifyOnStock';

const PDPAlertsSection = ({ showOutOfStockNotification }) => (
  <div>
    <PDPAlertBar type="error">
      {showOutOfStockNotification.eta
        ? `Sorry - looks like this product has sold out. Don't worry, we estimate this will be restocked on ${showOutOfStockNotification.eta}`
        : "Sorry, we're sold out of this product!"}
    </PDPAlertBar>

    {showOutOfStockNotification?.show ? (
      <PDPNotifyOnStock id={showOutOfStockNotification.productId} />
    ) : (
      <div className="PDPAlertsSection__PDPNotifyOnStock-filler" />
    )}
  </div>
);

PDPAlertsSection.propTypes = {
  showOutOfStockNotification: PropTypes.shape({
    show: PropTypes.bool,
    productId: PropTypes.number,
    eta: PropTypes.string,
  }),
};

export default PDPAlertsSection;
